import {
    ACCREDITATION_LOAD_FORCATALOGITEM,
    ACCREDITATION_LOAD_FORUSER,
    ACCREDITATION_RETRY,
} from '@/accreditation/actions/accreditation.js';
import {mergeRetriedAccreditation} from '@/accreditation/accreditationHelpers.js';

const init = {
    loading: true,
    targetId: null,
    idString: null,
    list: [],
    pageIndex: -1,
    // Retry of one accreditation: the id being sent, the row as it came back, or why it was refused
    // (the error and the id of the row it belongs to, shown in that row).
    retryingId: null,
    retried: null,
    retryError: null,
    retryErrorId: null,
};

const app = (state = init, action) => {
    const {type, payload, meta} = action;

    switch (type) {
        case `${ACCREDITATION_RETRY}_PENDING`:
            return {
                ...state,
                retryingId: meta?.id ?? null,
                retried: null,
                retryError: null,
                retryErrorId: null,
            };
        case `${ACCREDITATION_RETRY}_FULFILLED`:
            return {
                ...state,
                list: state.list.map((x) =>
                    x.id === payload.id ? mergeRetriedAccreditation(x, payload) : x,
                ),
                retryingId: null,
                retried: payload,
                retryError: null,
                retryErrorId: null,
            };
        case `${ACCREDITATION_RETRY}_REJECTED`:
            return {
                ...state,
                retryingId: null,
                retried: null,
                retryError: payload ?? new Error('retry failed'),
                retryErrorId: meta?.id ?? null,
            };
        case `${ACCREDITATION_LOAD_FORCATALOGITEM}_PENDING`:
        case `${ACCREDITATION_LOAD_FORUSER}_PENDING`:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case `${ACCREDITATION_LOAD_FORCATALOGITEM}_FULFILLED`:
        case `${ACCREDITATION_LOAD_FORUSER}_FULFILLED`:
            return {
                ...state,
                loading: false,
                idString: payload.idString ?? null,
                targetId: payload.targetId ?? null,
                list:
                    payload.pageIndex === 0 ? [...payload.list] : [...state.list, ...payload.list],
                pageIndex: payload.pageIndex,
                total: payload.total,
            };
        case `${ACCREDITATION_LOAD_FORCATALOGITEM}_REJECTED`:
        case `${ACCREDITATION_LOAD_FORUSER}_REJECTED`:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        default:
            return state;
    }
};

export default app;
